import React from 'react';
import { Button } from './ui/button';
import { DollarSign, TrendingUp, Zap } from 'lucide-react';

const MonetizationFeature = () => {
  return (
    <section id="features" className="py-24 bg-gradient-to-b from-black via-purple-950/10 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Turn Their Love into
            <span className="bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent"> Revenue</span>
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image/Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 border border-white/10 shadow-2xl">
              <div className="space-y-6">
                {/* Mock Ad Integration UI */}
                <div className="bg-black/50 rounded-xl p-6 border border-purple-500/30">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center">
                      <Zap className="text-white" size={20} />
                    </div>
                    <div>
                      <div className="text-white font-semibold">Ad Integration</div>
                      <div className="text-gray-400 text-sm">One-prompt setup</div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-lg p-4 border border-purple-500/30">
                    <code className="text-purple-300 text-sm">
                      "Add rewarded video ads after each level completion"
                    </code>
                  </div>
                </div>

                {/* Revenue Stats */}
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-black/50 rounded-xl p-4 border border-green-500/30">
                    <div className="flex items-center gap-2 mb-2">
                      <DollarSign className="text-green-400" size={16} />
                      <span className="text-gray-400 text-sm">Day 1 Revenue</span>
                    </div>
                    <div className="text-2xl font-bold text-white">$247</div>
                  </div>
                  <div className="bg-black/50 rounded-xl p-4 border border-green-500/30">
                    <div className="flex items-center gap-2 mb-2">
                      <TrendingUp className="text-green-400" size={16} />
                      <span className="text-gray-400 text-sm">Growth</span>
                    </div>
                    <div className="text-2xl font-bold text-green-400">+34%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-white mb-4">
                Insert ads in just one prompt.
              </h3>
              <p className="text-gray-400 text-lg">
                Built-in ads from top ad networks, no extra setup required
              </p>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-white mb-4">
                Keep 90% of all revenue.
              </h3>
              <p className="text-gray-400 text-lg">
                Fair revenue sharing: You earn 90%, we take 10% platform fee
              </p>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-white mb-4">
                Monetize from day one.
              </h3>
              <p className="text-gray-400 text-lg">
                Revenue from the first player, scale with every session
              </p>
            </div>

            {/* Features List */}
            <div className="space-y-4">
              {[
                'Multiple ad formats: Banner, Interstitial, Rewarded Video',
                'Top ad networks pre-integrated',
                'Real-time revenue analytics',
                'Automatic optimization for maximum earnings'
              ].map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-gray-300">{feature}</span>
                </div>
              ))}
            </div>

            <Button
              size="lg"
              data-testid="monetization-try-free-btn"
              onClick={() => window.location.href = '/create'}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8"
            >
              Try it Free
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MonetizationFeature;